import '.jg{border-top:1px solid var(--gray-100);}.ssr-plugin'
import '.jh{padding-top:0.5rem;}.ssr-plugin'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { PostActivityRow } from './blocks/PostActivityRow'
import { useRef, useEffect, useState } from 'react'
import { useAuthState } from '@based/sdk/react'
import { PostMediaGallery } from '../mediaGallery/PostMediaGallery'
import { styled } from 'inlines'
import useDateFormat from '@app/util/useDateFormat'
import { ReplyTextBox } from './blocks/ReplyTextBox'
import { PostProps } from './blocks/models'
import { Comment } from './blocks/Comment'
import { LoadMoreCommentsButton } from './blocks/LoadMoreButton'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'

export const Post = ({
  post: {
    id,
    authorName,
    authorAvatar,
    creationDate,
    content,
    media,
    reactionUserIds,
    comments,
    hasMoreComments,
  },
  onReply,
  onReact,
  onLoadMoreComments,
}: PostProps) => {
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.post
  const authState = useAuthState()
  const [mounted, setMounted] = useState(false)

  const postReplyRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setMounted(true)
  }, [])

  const hasReaction = !!(
    mounted &&
    authState.userId &&
    reactionUserIds.includes(authState.userId.toString())
  )
  const dateFormat = useDateFormat(true)
  const postReplyCount = comments.reduce(
    (prev, next) => (prev += next.comments.length),
    comments.length,
  )
  return (
    <Column
      gap="0.5rem"
      alignItems="stretch"
      style={{
        padding: '1rem 1.5rem',
        backgroundColor: 'var(--palette-white)',
        borderRadius: '1.25rem',
        border: 'var(--border-default)',
      }}
    >
      <Column
        gap="1rem"
        style={{ marginBottom: '0.5rem' }}
        alignItems="stretch"
      >
        <Row gap="0.5rem">
          <Avatar size="small" image={authorAvatar} labelSource={authorName} />
          <Column gap="0.25rem">
            <Text.Medium isBold={true}>{authorName}</Text.Medium>
            <Text.Small style={{ color: 'var(--gray-300)' }}>
              {dateFormat(creationDate)}
            </Text.Small>
          </Column>
        </Row>
        <Text.Medium style={{ lineHeight: '1.75rem' }}>{content}</Text.Medium>
        <PostMediaGallery images={media} />
      </Column>
      <PostActivityRow
        version="post"
        hasReaction={hasReaction}
        reactions={reactionUserIds.length}
        comments={postReplyCount}
        onReactionClick={() => onReact(id)}
        onReplyClick={() =>
          postReplyRef.current && postReplyRef.current.focus()
        }
      />
      {comments.map((comment, index) => (
        <Comment
          key={index}
          post={comment}
          level="comment"
          onReact={onReact}
          onReply={onReply}
          loadMoreComments={comment.hasMoreComments ? () => {} : undefined}
        />
      ))}
      {hasMoreComments && (
        <LoadMoreCommentsButton
          label={translations.loadMoreComments}
          onClick={() => onLoadMoreComments?.(id)}
        />
      )}
      <div className="jg jh"
      >
        <ReplyTextBox
          ref={postReplyRef}
          onSumbit={async (text) => await onReply(id, text)}
        />
      </div>
    </Column>
  )
}
